var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lex-web"
    }
  }, [_c('page'), _vm._v(" "), _c('toolbar-container', {
    attrs: {
      "toolbar-title": _vm.toolbarTitle,
      "toolbar-color": _vm.toolbarColor,
      "toolbar-logo": _vm.toolbarLogo,
      "is-ui-minimized": _vm.isUiMinimized
    },
    on: {
      "toggleMinimizeUi": _vm.toggleMinimizeUi
    }
  }), _vm._v(" "), _c('message-list'), _vm._v(" "), _c('status-bar'), _vm._v(" "), _c('input-container', {
    attrs: {
      "text-input-placeholder": _vm.textInputPlaceholder,
      "initial-text": _vm.initialText,
      "initial-speech-instruction": _vm.initialSpeechInstruction
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4973da9d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LexWeb.vue
// module id = 203
// module chunks = 1